import React from "react";
import { SovosBox, SovosTypography } from "mosaic-react";

const StatTile = ({ label, value, borderColor }) => (
    <SovosBox
        sx={{
            flex: "1 1 180px",
            minWidth: { md: 0, xs: "100%" },
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            borderBottom: "3px solid",
            borderBottomColor: borderColor,
            bgcolor: "background.paper",
        }}
    >
        <SovosTypography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
            {label}
        </SovosTypography>
        <SovosTypography variant="h5" fontWeight={700}>
            {value}
        </SovosTypography>
    </SovosBox>
);

export default StatTile;
